{
  "id": "campaign-145",
  "name": "Breezy Pasture",
  "seed": "campaign:145",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ".........x....x...",
    "..#..T......#.....",
    "......x.......T...",
    ".T..........h.....",
    ".........ww.......",
    "....wwww+wwww+w...",
    "www+w.........wwww",
    "w.................",
    ".........Y.....T..",
    "...x.........#....",
    "....T..........T.T",
    "..................",
    ".....m.m....T.....",
    "......m.x.....T...",
    "....#.T...........",
    ".......#...T......",
    ".........#....h...",
    "..T.........h..m..",
    "S.............mm.."
  ],
  "critters": [
    {
      "kind": "stag",
      "x": 12,
      "y": 16
    },
    {
      "kind": "fox",
      "x": 11,
      "y": 11
    },
    {
      "kind": "deer",
      "x": 14,
      "y": 8
    },
    {
      "kind": "deer",
      "x": 14,
      "y": 7
    },
    {
      "kind": "fox",
      "x": 8,
      "y": 17
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 2,
      "y": 7
    },
    {
      "kind": "gas",
      "x": 6,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 13,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 12,
      "y": 15
    },
    {
      "kind": "repair",
      "x": 17,
      "y": 8
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "hills": [
    {
      "x": 1,
      "y": 11,
      "w": 5,
      "h": 5
    }
  ],
  "generatorVersion": 3,
  "level": 145,
  "biome": "meadow",
  "par": {
    "reel": 11470,
    "push": 9949,
    "selfPropelled": 9174,
    "tractor": 7490,
    "zeroTurn": 6512,
    "fairway": 4171
  },
  "goldTime": {
    "reel": 11470,
    "push": 9949,
    "selfPropelled": 9174,
    "tractor": 7490,
    "zeroTurn": 6512,
    "fairway": 4087
  },
  "routeTries": {
    "par": {
      "reel": 3,
      "push": 22,
      "selfPropelled": 0,
      "tractor": 16,
      "zeroTurn": 0,
      "fairway": 5
    },
    "gold": {
      "reel": 3,
      "push": 22,
      "selfPropelled": 0,
      "tractor": 16,
      "zeroTurn": 0,
      "fairway": 46
    }
  }
}
